import React, { useContext } from 'react';
import { FaHome, FaSearch, FaShoppingCart, FaUser } from 'react-icons/fa';
import { CartContext } from '../contexts/CartContext';
import {
  BottomNavContainer,
  BottomNavItem,
  CartBadge
} from './BottomNavElements';

const BottomNav = () => {
  const { itemCount } = useContext(CartContext);

  return (
    <BottomNavContainer>
      <BottomNavItem exact to="/">
        <FaHome />
        <span>Home</span>
      </BottomNavItem>
      
      <BottomNavItem to="/discover">
        <FaSearch />
        <span>Discover</span>
      </BottomNavItem>
      
      <BottomNavItem to="/cart">
        <FaShoppingCart />
        <span>Cart</span>
        {itemCount > 0 && <CartBadge>{itemCount}</CartBadge>}
      </BottomNavItem>
      
      <BottomNavItem to="/profile">
        <FaUser />
        <span>Profile</span>
      </BottomNavItem>
    </BottomNavContainer>
  );
};

export default BottomNav;
